import evenShotBg from '@/assets/juicybet/images/backgrounds/evenShotBg.png';
import evenShot from '@/assets/juicybet/images/evenShotMascot.png';
import { EvenShotSchema } from './EvenShot.styles';

export const evenShotStyles: EvenShotSchema = {
  notAvailableText: {
    color: 'gamma.400',
    marginTop: 0,
  },
  oddsValueSpan: {
    color: 'white',
    sx: {
      '&[data-hasbets="true"]': {
        color: 'gamma.400',
      },
    },
  },
  hasBetSubTitleText: {
    fontWeight: 'normal',
  },
  comeBackLaterText: {
    color: 'white',
  },
  notYetAvailableText: {
    color: 'gamma.400',
    fontWeight: 'bold',
    mt: 0,
  },
  subHeadingText: {
    fontSize: 'sm',
  },
  betPlacedText: {
    textTransform: 'uppercase',
    color: 'gamma.400',
    textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    fontWeight: 'extrabold',
    fontSize: 'lg',
  },
  oddsText: {
    mt: '0',
    mb: '4',
    fontWeight: 'extrabold',
    fontSize: 'lg',
    textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  flexWrapper: {
    border: '2px',
    borderColor: 'beta.600',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    flexDir: 'column',
    bg: `linear-gradient(180deg, #00A443 0%, #077735 100%), url(${evenShotBg})`,
    bgBlendMode: 'overlay, normal',
    bgSize: 'cover',
    minH: 'calc(100vh - 350px)',
  },
  headingText: {
    fontFamily: 'Chewy',
    fontWeight: 'normal',
    color: 'alpha.50',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
    textTransform: 'uppercase',
    fontSize: '49px',
  },
  addToBetslipButton: {
    variant: 'secondary',
  },
  loginToView: {
    variant: 'secondary',
  },
  evenShotImage: {
    mt: 4,
    mb: 0,
    boxSize: '146px',
    backgroundImage: `url(${evenShot})`,
    backgroundSize: 'cover',
  },
};
